import { useOrganisation } from "../../../providers/OrganisationProvider";
import { FederatedOrganisationsPageSkeleton } from "./FederatedOrganisationsPageSkeleton";
import { FederatedOrganisations } from "../../../layout/organisation/FederatedOrganisations";

const FederatedOrganisationsPage = () => {
    const organisation = useOrganisation();

    if (!organisation) return <FederatedOrganisationsPageSkeleton/>;
    return <FederatedOrganisations organisation={organisation}/>;
};
export default FederatedOrganisationsPage;
